<template>
  <el-card>
    <template #header>
      <div class="card-header">
        <span>关于我们</span>
      </div>
    </template>
    <p>这里是关于我们页面的相关介绍内容。</p>
  </el-card>
</template>

<script setup>
// 关于我们页面逻辑
</script>

<style scoped>
/* 关于我们页面样式 */
</style>